import React, { useCallback, useEffect, useState } from "react";
import { Select } from 'semantic-ui-react';
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import {
  ButtonFaixa,
  Container,
  ContainerFlip,
  ContainerTimer,
  Content,
  DataContainer,
  FaixaPreview,
  Field,
  FlipDigitContainerStyle,
  FlipUnitContainerStyle,
  Input,
  Label,
  Title
} from "./styles";

import { withRouter } from "react-router-dom";
import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import { getUserNode } from "../../../../services/auth_node";

import { Checkbox, Dropdown, Form, Icon } from "semantic-ui-react";
import swal from "sweetalert";

const FlipUnitContainer = ({ digit, unit, backgroundColor, colorUnit, color }) => (
  <FlipUnitContainerStyle colorUnit={colorUnit}>
    <p>{unit}</p>
    <FlipDigitContainerStyle backgroundColor={backgroundColor} color={color}>
      <span>{digit.toString()}</span>
    </FlipDigitContainerStyle>
  </FlipUnitContainerStyle>
);


const FaixasCriar = (props) => {
  const [active, setActive] = useState(false);
  const [enunciado, setEnunciado] = useState("");
  const [enunciadoBotao, setEnunciadoBotao] = useState("");
  const [link, setLink] = useState("");
  const [corFundoFaixa, setCorFundoFaixa] = useState("#000");
  const [corFundoBotao, setCorFundoBotao] = useState("#f2711c");
  const [corFaixa, setCorFaixa] = useState("#fff");
  const [corBotao, setCorBotao] = useState("#fff");

  const [timerActive, setTimerActive] = useState(false);
  const [corTimerUnit, setCorTimerUnit] = useState("#fff");
  const [corTimerDigit, setCorTimerDigit] = useState("#a0f");
  const [corBackgroundTimer, setCorBackgroundTimer] = useState("#ccc");
  const [dataTimer, setDataTimer] = useState(
    new Date(new Date().toLocaleString("pt", { timeZone: "America/Sao_Paulo" }))
  );

  const [temTimer, setTemTimer] = useState(false);

  const [diaArr, setDiaArr] = useState([]);
  const [horArr, setHorArr] = useState([]);
  const [minArr, setMinArr] = useState([]);

  const [mesFinal, setMesFinal] = useState(new Date().getMonth());
  const [anoFinal, setAnoFinal] = useState(new Date().getFullYear());

  const [tipo, setTipo] = useState("top");
  const [dataStartTimer, setDataStartTimer] = useState(new Date());
  const [dataEndFaixa, setDataEndFaixa] = useState(new Date());
  const [pages, setPages] = useState("all");

  const mesArr = [
    { key: "1", text: "Janeiro", value: "0" },
    { key: "2", text: "Fevereiro", value: "1" },
    { key: "3", text: "Março", value: "2" },
    { key: "4", text: "Abril", value: "3" },
    { key: "5", text: "Maio", value: "4" },
    { key: "6", text: "Junho", value: "5" },
    { key: "7", text: "Julho", value: "6" },
    { key: "8", text: "Agosto", value: "7" },
    { key: "9", text: "Setembro", value: "8" },
    { key: "10", text: "Outubro", value: "9" },
    { key: "11", text: "Novembro", value: "10" },
    { key: "12", text: "Dezembro", value: "11" },
  ];

  const anoArr = [
    {
      key: "1",
      text: new Date().getFullYear(),
      value: new Date().getFullYear(),
    },
    {
      key: "2",
      text: new Date().getFullYear() + 1,
      value: new Date().getFullYear() + 1,
    },
    {
      key: "3",
      text: new Date().getFullYear() + 2,
      value: new Date().getFullYear() + 2,
    },
    {
      key: "4",
      text: new Date().getFullYear() + 3,
      value: new Date().getFullYear() + 3,
    },
  ];

  useEffect(() => {
    loadAuth();
  
    setHorArr(Array.from({ length: 24 }, (_, i) => ({ key: i + 1, text: i, value: i })));
    setMinArr(Array.from({ length: 60 }, (_, i) => ({ key: i + 1, text: i, value: i })));
  
    const newDate = new Date(0);
    newDate.setFullYear(anoArr[0].value);
    newDate.setHours(23, 59, 59);
  
    setDataTimer(newDate);
    setDataStartTimer(new Date(newDate));
    setDataEndFaixa(new Date(newDate));
  }, [temTimer]);
  
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  useEffect(() => {
    setDiaArr(getDaysInMonth(mesFinal, anoFinal));
  }, [mesFinal, anoFinal, temTimer]);

  useEffect(() => {
    if (!getUserNode().admin) {
      props.history.push("/login");
      return;
    }
  }, []);

  const getDaysInMonth = useCallback((month, year) => {
    const date = new Date(year, month + 1, 0);
    const numberOfDays = date.getDate();
    return Array.from({ length: numberOfDays }, (_, i) => ({
      key: i + 1,
      text: i + 1,
      value: i + 1,
    }));
  });
  

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      api
        .post("faixas", {
          enunciado,
          enunciado_botao: enunciadoBotao,
          link,
          cor_faixa: corFaixa,
          cor_botao: corBotao,
          cor_fundo_faixa: corFundoFaixa,
          cor_fundo_botao: corFundoBotao,
          cor_timer_box: corBackgroundTimer,
          cor_timer_digit: corTimerDigit,
          cor_timer_unit: corTimerUnit,
          timer_active: timerActive,
          data_limite_timer: dataTimer.toISOString(),
          data_start_timer: dataStartTimer.toISOString(),
          data_end_faixa: dataEndFaixa.toISOString(),
          active,
          tipo,
          pages,
        })
        .then((res) => {
          let logs = { local: "faixa", texto: `criou a faixa` };
          api.post("system_logs", { acao: JSON.stringify(logs) });
          swal(
            "Requisição bem sucedida",
            "Faixa criado com sucesso",
            "success"
          );
        })
        .catch((err) => {
          console.error(err);
          swal(
            "Requisição mal sucedida",
            "Não foi possível efetuar a criação de faixa",
            "error"
          );
        });
    },
    [
      enunciado,
      enunciadoBotao,
      link,
      corFaixa,
      corBotao,
      corFundoFaixa,
      corFundoBotao,
      active,
      corBackgroundTimer,
      corTimerDigit,
      corTimerUnit,
      timerActive,
      dataTimer,
    ]
  );

  
  return (
    <Container>
      <AdminMenu />

      <Content>
        <Title>Criar faixa fixa para o site</Title>

        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>Enunciado</Label>
            <Input
              value={enunciado}
              onChange={(e) => setEnunciado(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Enunciado Botão</Label>
            <Input
              value={enunciadoBotao}
              onChange={(e) => setEnunciadoBotao(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Link</Label>
            <Input value={link} onChange={(e) => setLink(e.target.value)} />
          </Field>

          <Field>
            <Label>Cor do Texto da Faixa</Label>
            <Input
              value={corFaixa}
              onChange={(e) => setCorFaixa(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Cor do Fundo da Faixa</Label>
            <Input
              value={corFundoFaixa}
              onChange={(e) => setCorFundoFaixa(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Cor do Texto do Botao</Label>
            <Input
              value={corBotao}
              onChange={(e) => setCorBotao(e.target.value)}
            />
          </Field>

          <Field>
            <Label>Cor do Fundo do Botao</Label>
            <Input
              value={corFundoBotao}
              onChange={(e) => setCorFundoBotao(e.target.value)}
            />
          </Field>

          <Field>
            <Checkbox
              label="Cronômetro"
              checked={temTimer}
              onChange={(e) => setTemTimer(!temTimer)}
            />
          </Field>

          <Field>
            <Label>Tipo</Label>
             <Select value={tipo} onChange={(e) => setTipo(e.target.value)}>
               <option value="middle">Middle</option>
               <option value="bottom">Bottom</option>
              </Select>
           </Field>
           <span>Obs: "Middle" significa banner superior e "Bottom" significa banner inferior</span>
          <Field>
            <Label>Páginas</Label>
            <Input value={pages} onChange={(e) => setPages(e.target.value)} />
          </Field>

          {temTimer ? (
            <div>
              <Field>
                <Label>Data Início</Label>
                <DataContainer>
                  <Dropdown
                    defaultValue={diaArr[0].value}
                    placeholder="Dia"
                    selection
                    search
                    options={diaArr}
                    onChange={(e, value) => {
                      setDataStartTimer(
                        new Date(dataStartTimer.setDate(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={mesArr[0].value}
                    placeholder="Mês"
                    selection
                    search
                    options={mesArr}
                    onChange={(e, value) => {
                      setMesFinal(parseInt(value.value));
                      setDataStartTimer(
                        new Date(dataStartTimer.setMonth(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={anoArr[0].value}
                    placeholder="Ano"
                    selection
                    search
                    options={anoArr}
                    onChange={(e, value) => {
                      setAnoFinal(parseInt(value.value));
                      setDataStartTimer(
                        new Date(
                          dataStartTimer.setFullYear(parseInt(value.value))
                        )
                      );
                    }}
                  />
                </DataContainer>

                <DataContainer>
                  <Dropdown
                    defaultValue={23}
                    placeholder="Hora"
                    selection
                    search
                    options={horArr}
                    onChange={(e, value) => {
                      setDataStartTimer(
                        new Date(dataStartTimer.setHours(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={59}
                    placeholder="Minuto"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataStartTimer(
                        new Date(
                          dataStartTimer.setMinutes(parseInt(value.value))
                        )
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={59}
                    placeholder="Segundo"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataStartTimer(
                        new Date(
                          dataStartTimer.setSeconds(parseInt(value.value))
                        )
                      );
                    }}
                  />
                </DataContainer>
              </Field>

              <Field>
                <Label>Data Final da FAIXA</Label>
                <DataContainer>
                  <Dropdown
                    defaultValue={diaArr[0].value}
                    placeholder="Dia"
                    selection
                    search
                    options={diaArr}
                    onChange={(e, value) => {
                      setDataEndFaixa(
                        new Date(dataEndFaixa.setDate(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={mesArr[0].value}
                    placeholder="Mês"
                    selection
                    search
                    options={mesArr}
                    onChange={(e, value) => {
                      setMesFinal(parseInt(value.value));
                      setDataEndFaixa(
                        new Date(dataEndFaixa.setMonth(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={anoArr[0].value}
                    placeholder="Ano"
                    selection
                    search
                    options={anoArr}
                    onChange={(e, value) => {
                      setAnoFinal(parseInt(value.value));
                      setDataEndFaixa(
                        new Date(
                          dataEndFaixa.setFullYear(parseInt(value.value))
                        )
                      );
                    }}
                  />
                </DataContainer>

                <DataContainer>
                  <Dropdown
                    defaultValue={23}
                    placeholder="Hora"
                    selection
                    search
                    options={horArr}
                    onChange={(e, value) => {
                      setDataEndFaixa(
                        new Date(dataEndFaixa.setHours(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={59}
                    placeholder="Minuto"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataEndFaixa(
                        new Date(dataEndFaixa.setMinutes(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={59}
                    placeholder="Segundo"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataEndFaixa(
                        new Date(dataEndFaixa.setSeconds(parseInt(value.value)))
                      );
                    }}
                  />
                </DataContainer>
              </Field>

              <Field>
                <Label>Data Final</Label>
                <DataContainer>
                  <Dropdown
                    defaultValue={diaArr[0].value}
                    placeholder="Dia"
                    selection
                    search
                    options={diaArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setDate(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={mesArr[0].value}
                    placeholder="Mês"
                    selection
                    search
                    options={mesArr}
                    onChange={(e, value) => {
                      setMesFinal(parseInt(value.value));
                      setDataTimer(
                        new Date(dataTimer.setMonth(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={anoArr[0].value}
                    placeholder="Ano"
                    selection
                    search
                    options={anoArr}
                    onChange={(e, value) => {
                      setAnoFinal(parseInt(value.value));
                      setDataTimer(
                        new Date(dataTimer.setFullYear(parseInt(value.value)))
                      );
                    }}
                  />
                </DataContainer>

                <DataContainer>
                  <Dropdown
                    defaultValue={23}
                    placeholder="Hora"
                    selection
                    search
                    options={horArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setHours(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={59}
                    placeholder="Minuto"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setMinutes(parseInt(value.value)))
                      );
                    }}
                  />
                  <Dropdown
                    defaultValue={59}
                    placeholder="Segundo"
                    selection
                    search
                    options={minArr}
                    onChange={(e, value) => {
                      setDataTimer(
                        new Date(dataTimer.setSeconds(parseInt(value.value)))
                      );
                    }}
                  />
                </DataContainer>
              </Field>

              <Field>
                <Label>Cor da unidade</Label>
                <Input
                  value={corTimerUnit}
                  onChange={(e) => setCorTimerUnit(e.target.value)}
                />
              </Field>

              <Field>
                <Label>Cor dos digitos</Label>
                <Input
                  value={corTimerDigit}
                  onChange={(e) => setCorTimerDigit(e.target.value)}
                />
              </Field>

              <Field>
                <Label>Cor de fundo do timer</Label>
                <Input
                  value={corBackgroundTimer}
                  onChange={(e) => setCorBackgroundTimer(e.target.value)}
                />
              </Field>

              <Field>
                <Checkbox
                  label="Cronômetro - Ativo"
                  checked={timerActive}
                  onChange={(e) => setTimerActive(!timerActive)}
                />
              </Field>
            </div>
          ) : null}

          <Field>
            <Checkbox
              label="Ativo"
              checked={active}
              onChange={(e) => setActive(!active)}
            />
          </Field>

          <h3>Preview:</h3>
          <FaixaPreview
            href={link}
            target="_blank"
            color={corFaixa}
            backgroundColor={corFundoFaixa}
          >
            <p>{enunciado}</p>
            {temTimer ? (
              <ContainerTimer>
                <ContainerFlip colorUnit={corTimerUnit}>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Dias"}
                    digit={"1"}
                  />{" "}
                  <span> : </span>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Horas"}
                    digit={"19"}
                  />{" "}
                  <span> : </span>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Min"}
                    digit={"55"}
                  />{" "}
                  <span> : </span>
                  <FlipUnitContainer
                    backgroundColor={corBackgroundTimer}
                    colorUnit={corTimerUnit}
                    color={corTimerDigit}
                    unit={"Seg"}
                    digit={"12"}
                  />
                </ContainerFlip>
              </ContainerTimer>
            ) : null}

            <ButtonFaixa
              color={corBotao}
              backgroundColor={corFundoBotao}
              onClick={(e) => {
                e.preventDefault();
                window.open(link);
              }}
            >
              {enunciadoBotao}
            </ButtonFaixa>
          </FaixaPreview>

          <ButtonFaixa color={"black"}>
            <Icon name="user plus" /> Salvar
          </ButtonFaixa>
        </Form>
      </Content>
    </Container>
  );
};

export default withRouter(FaixasCriar);
